import React from 'react';

import { ThemeProvider } from '@bessemercws/components';
import {
  GetClientSessionIdFragmentDoc,
  useFragment,
  UsePostUserMetricsMutationProps,
  useRecordButtonAction,
} from '@bessemercws/graphql';
import { useClientContext } from '@bessemercws/providers';
import { SnackbarProvider } from '@bessemercws/utils';
import { Routes } from 'react-router-dom';

import { ErrorBoundary } from './components';
import { UserVerificationProvider } from './components/UserVerificationContext/UserVerificationContext';
import ClientRoutes from './routes/ClientRoutes';
import EmulatorRoutes from './routes/EmulatorRoutes';

export const AppTheme = () => {
  const { authSessionId, userId, isAdvisor, selectedClient } = useClientContext();
  const userKey = isAdvisor ? selectedClient : userId;
  const { data, complete } = useFragment({
    fragment: GetClientSessionIdFragmentDoc,
    from: `User:${userKey}`,
  });

  const sessionId = complete ? data.sessionId : authSessionId;

  const trackerConfig: UsePostUserMetricsMutationProps = {
    sessionId: sessionId || '',
    isAdvisor,
  };

  const { recordButtonAction } = useRecordButtonAction(trackerConfig);

  return (
    <ThemeProvider license={import.meta.env.VITE_MUIX_PRO_KEY || ''} trackingCallback={recordButtonAction}>
      <SnackbarProvider>
        <ErrorBoundary>
          <UserVerificationProvider>
            <Routes>
              {ClientRoutes()}
              {EmulatorRoutes()}
            </Routes>
          </UserVerificationProvider>
        </ErrorBoundary>
      </SnackbarProvider>
    </ThemeProvider>
  );
};
